<template lang="">
    <div class="modal fade" :id="modalId" ref="modalEl" tabindex="-1"  :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">Send Application</div>
         <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
          </button>
      </div>
      <div class="modal-body">

         <div v-if="!completed" class="job-card m2-2">
            <img :src="profileImage" 
            @error="setDefaultImage"
            alt="Company logo"
            class="logo" />
            <div class="details">
              
              <div class="company">    
                <div class="job-title">
                  {{ jobItem.jobTitle }}
                </div>
                <div class="company-name">
                  {{ jobItem.name }}
                </div>
              </div>

               <div class="type job-detail">
                <BriefcaseJobIcon class="job-icon"/><div class="detail">{{ jobItem.jobType || '--' }}</div>
              </div>
              <div class="location job-detail">
                <PinIcon class="job-icon"/><div class="detail">{{ jobItem.location }}</div> 
              </div>
              <div class="closing-date job-detail">
                <CalendarIcon class="job-icon"/> <div class="detail">{{ jobItem.closingDate }}</div>
              </div>
            </div>
          </div>

        <form v-if="!completed">       
          <div class="form-group mb-3">
            <label class="form-label">Attach Documents</label>
            <input type="file" ref="fileUpload" @change="filesSelected" multiple accept=".pdf,.docx" class="form-control" id="inputGroupFile01">
          </div>
          <div v-show="fileSelected" class="form-group mb-3">
            <div class="file-list">
              <div v-for="file in files" class="file-item">
                <div class="file-icon-box">
                  <FileIcon class="file-icon"/>
                </div>
                <div class="file-name">{{file.name}}</div>
                <button class="btn btn-default delete-file btn-sm" @click.prevent="deleteFile(files.indexOf(file))">
                  <CloseIcon class="close-icon"/>
                </button>
            </div>
            </div>
          </div>
           <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" v-model="usedPlatformCV" id="checkDefault">
              <label class="form-check-label" for="checkDefault">
                Pin Vocation&trade; generated CV
              </label>
            </div>
          <button type="button mb-3 send-btn" :disabled="loading"
          @click.prevent="sendApplicationAsync" class="btn btn-send btn-secondary btn-sm" style="color:white;">
          <img src="@/assets/icons/mail.svg" :class="loading == true ? 'send-icon sending':'send-icon'"/>
            </button>
        </form>
        <!-- errors -->
          <div class="errors" v-if="hasErrors" style="margin-top:1rem;">
              <div class="error" v-for="error in errors">{{ error }}</div>
          </div>
          <!-- errors -->  
        <!-- <div class="completed" v-if="completed">
          <div class="completed-message">Your application has been sent.</div>
        </div> -->

        <ApplicationSuccessMessage v-if="completed"/>

      </div>
      <!-- <div class="modal-footer"> 
      </div> -->
    </div>
  </div>
</div>
</template>
<script>
import { Modal } from 'bootstrap';
import FileIcon from '../IconComponents/FileIcon.vue';
import CloseIcon from '../IconComponents/CloseIcon.vue';
import { SendJobApplicationAsync } from '@/services/public/vacancyService';
import BriefcaseJobIcon from '../IconComponents/BriefcaseJobIcon.vue';
import PinIcon from '../IconComponents/PinIcon.vue';
import CalendarIcon from '../IconComponents/CalendarIcon.vue';
import ApplicationSuccessMessage from '../ApplicationSuccessMessage.vue';
export default {
  components:{
    CloseIcon,
     FileIcon,
     CloseIcon,
    BriefcaseJobIcon,
    PinIcon,
    CalendarIcon,
    ApplicationSuccessMessage
  },
   data(){
    return{
        loading: false,
        files: [],
        usedPlatformCV: false,
        fileSelected: false,
        url:process.env.VUE_APP_API_URL,
        jobItem:{},
        errors:[],
            loading:false,
            hasErrors:false,
            completed:false
    }
   },
    props:{
        closeModal:{
            type: Function,
            required: false            
        },
        modalId:{
            type: String,
            required: true
        }
    },
  computed:{
    profileImage(){
      return this.url + 'Auth/Image/' + this.jobItem.id;
    }
  },
     mounted() {
      this.modalInstance = new Modal(this.$refs.modalEl);
  },
    methods: {
      async sendApplicationAsync(){
            try{
            this.loading = true;
            this.completed = false;
            this.hasErrors = false;
            this.errors = [];

            let formData = new FormData();
           
              this.files.forEach(file => {
            if (file instanceof File) {
                    formData.append("Attachments", file);
                }
            });
            formData.append('UsedPlatformCV', this.usedPlatformCV)
            formData.append('JobId', this.jobItem.jobId );
            formData.append('CompanyPublicKey', this.jobItem.id);
            var response = await SendJobApplicationAsync(formData, () => this.hide())
            if(!response.success){
                this.loading = false;
                    if(!response.errors){
                        const err = new Error(response.message, {reason: response.caption});
                        err.caption = response.caption;
                        throw err;
                    }else{
                        this.errors = response.errors;
                        this.hasErrors = true
                    }
                }else{
                    this.loading = false;
                    this.completed = true;
                    this.usedPlatformCV = false;
                    this.fileSelected = false;
                    this.files = [];     
                    //setTimeout(() => this.completed = false, 5000);
                }
            }catch(e){
                this.errors.push(e.message);
                this.hasErrors = true;
                this.loading = false;
                this.completed = false;
                setTimeout(() => this.hasErrors = false, 5000);
            }
      },
      setVacancyDetails(job){
        this.jobItem = job;
      },
      filesSelected(){
        let uploads = this.$refs.fileUpload.files;
        let uploadsArray = Array.from(uploads).map(file => ({file}));
        this.insertUniqueFiles(uploadsArray);  
        if(this.files.length > 0){
          this.fileSelected = true;
        }   
        document.getElementById('inputGroupFile01').value = ''; 
      },
      insertUniqueFiles(source) {
        source.forEach(srcObj => {
            const exists = this.files.some(tgtObj => this.objectsAreEqual(srcObj, tgtObj));
            if (!exists) {
                this.files.push(srcObj.file);
            }
        });
    },
    objectsAreEqual(obj1, obj2) {
        // Quick check: same number of keys
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;

        // Check each key's value
        return keys1.every(key => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]);
      },
        
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.completed = false;
        this.modalInstance?.hide();
      },
      deleteFile(index){
        this.files.splice(index, 1);
        if(this.files.length == 0){
          this.fileSelected = false;
        }   
      },
      handleClose() {
        // Ensure the modal hides itself first, then call the parent's close handler
        this.hide();
        // if (typeof this.closeModal === 'function') {
        //   this.closeModal();
        // }
      }
    }


}
</script>
<style scoped>

.job-title{
   font-family: var(--heading-font-bold);
   font-size:1.3rem;
   color:var(--job-title);
   white-space:wrap;

}


.company-name{
  font-family: var(--heading-font-bold);
  font-size:0.9rem;
  margin-bottom:0.4rem;
  white-space:wrap;
}

.job-detail{
  display: flex;
  align-items: center;
  color:var(--darkgrey3);
}



.detail{
  font-family: var(--body-font);
  font-size:0.9rem;
  
}

.modal-content{
      /* border-radius:14px!important; */
}

.modal-body{
  /* border-bottom-left-radius:14px!important;
  border-bottom-right-radius:14px!important; */
}

.job-icon{
  height:1rem;
  margin-right:0.4rem;
  margin-top:-0.2rem;
  color:var(--darkgrey3);
}


.send-btn:focus{
  background-color:var(--secondary)!important;
}




   
    .completed{
        display: flex;
        justify-content: center;
        align-items: center;
        color:var(--page-header);
        margin-top:0.5rem;
        padding:0.7rem;
        border-radius: 8px;
    }


.job-card {
  display: flex;
  
  align-items: flex-start; /* keep everything left-aligned */
  border-radius: 6px;
  margin-bottom: 1rem;
  margin-right:1rem;
  column-gap:0.6rem;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem; /* space below image */
  border-radius: 4px;
  object-fit: cover;
  align-self: flex-start; /* force logo to left */
}

.details {
  width: 100%;
}

.location, .type, .closing-date{
  font-family: var(--heading-font2-regular);
  font-size:0.9rem;
}




/* Custom vertical scrollbar for WebKit browsers (Chrome, Edge, Safari) */
.file-list::-webkit-scrollbar {
  width: 8px;
}

.file-list::-webkit-scrollbar-track {
  background: var(--list-item);
  border-radius: 4px;
  margin:0.4rem 0rem;
}

.file-list::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-color);
  border-radius: 4px;
  border: 2px solid var(--list-item);
}

.file-list::-webkit-scrollbar-thumb:hover {
  background-color: var(--scrollbar-color);
}

.file-name{
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.modal-footer{
  height:0.1rem;
}

.file-icon-box{
  display: flex;
  align-items: center;
  margin-left:0.6rem;
}
.file-icon{
  justify-self: center;
}

.close-icon{
  color:var(--foreground);
}

.file-list{
  border:1px solid var(--file-list-border-color);
  padding:0.5rem;
  border-radius:8px;
  max-height:10rem;
  background-color: var(--nav);
  overflow-y: auto;
}

.file-item{
  display:grid;
  grid-template-columns:auto 1fr auto;
  column-gap:0.5rem;
  background-color:var(--background);
  border-radius:8px;
  margin-bottom:0.6rem;
  
}

.file-item:last-child{
  margin-bottom:0rem;
}

.btn-send{
    width:100%;
    border:0px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.7rem 0rem;
    background:var(--primary);
    
}

.doc-options{
    box-shadow:inset 7px 2px 12px grey;
    border-radius:8px;
    min-height:15rem;
}

.btn-send:hover{
    background:var(--secondary);
}


.send-icon{
    height:1rem;    
    transition:1s;
}

.bouncing{
    animation: bounce;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    transform: translateY(-3px);
    
}

.sending{
    animation: send;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    transform: translateX(0px);
    opacity: 1;
}


@keyframes send{
    from {
            transform: translateX(0px);
            opacity: 1;
        }
    to {
            transform: translateX(8px);
            opacity: 0;
        }
}

@keyframes bounce {
   from {transform: translateY(-3px);}
   to {transform: translateY(3px);}
}
    

  /* MODAL */
    .modal-body{
        color:var(--foreground);
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }

  

    .modal-header{
      border-bottom:0px;
    }
    
    @media(max-width: 768px) {

      .modal-dialog{
        margin-top:7rem;
      }

        .modal-body{
            min-height:20rem;
        }

          .location, .type, .closing-date{
              font-size:0.9rem;
            }
    }

   
</style>